const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCameraSetting(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uC0AC\\uAC01\\uD615 866",
    transform: "translate(1 3)",
    style: {
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    rx: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 16,
    rx: 1,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD0C0\\uC6D0 290",
    transform: "translate(5 8)",
    style: {
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 0.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 775",
    d: "M12144.04 9720.684h12v-6l-3.207 3.168-2.616-2.269z",
    transform: "translate(-12137.039 -9703.684)",
    style: {
      fill: "#fff",
      strokeLinejoin: "round",
      stroke: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCameraSetting);
export default __webpack_public_path__ + "static/media/btn-camera-setting.0a4ab596243d3e01664f361fdc1321c1.svg";
export { ForwardRef as ReactComponent };